import {
  EventDuplicateRequest,
  EventRequest,
  EventResponse,
  RescheduleEventRequest,
  checkReschedulePossible,
  createChatCleanup,
  deleteEvent,
  duplicateEvent,
  duplicateEventViaWorkflow,
  partialUpdateEvent,
  rescheduleEvent
} from '@goldcast/api/backend';

import { checkAndShowSalesforceConfig } from '@/studio/customSolutions/DoIt/util';

const state = {
  drawerOpen: false
};

const getters = {};

const mutations = {
  setDrawerOpen(state, value) {
    state.drawerOpen = value;
  }
};

const actions = {
  updateEvent(_, { eventId, payload }: { eventId: string; payload: Partial<EventRequest> }) {
    return new Promise((resolve, reject) => {
      partialUpdateEvent({
        id: eventId,
        body: {
          ...payload
        }
      })
        .then(event => {
          resolve({ eventId: event.id });
        })
        .catch(reject);
    });
  },
  clearChat(_, eventId: string) {
    return new Promise((resolve, reject) => {
      createChatCleanup({
        id: eventId,
        //@ts-ignore
        body: {}
      })
        .then(() => {
          resolve('Chat Cleared Successfully!');
        })
        .catch(reject);
    });
  },
  deleteEvent(_, { eventId, eventType }: { eventId: string; eventType?: string }) {
    return new Promise((resolve, reject) => {
      deleteEvent({
        id: eventId
      })
        .then(() => {
          resolve(`${eventType === 'Recording' ? 'Recording' : 'Event'} Deleted Successfully!`);
        })
        .catch(reject);
    });
  },
  rescheduleEvent(context, { payload, eventId }: { eventId: string; payload: RescheduleEventRequest }) {
    return new Promise((resolve, reject) => {
      rescheduleEvent({
        id: eventId,
        body: {
          ...payload
        }
      })
        .then(() => {
          resolve('Event Rescheduled Successfully!');
          context.commit(
            'studioEventList/partialUpdateEvent',
            { eventId, partialEvent: payload },
            {
              root: true
            }
          );
        })
        .catch(reject);
    });
  },
  async isEventReschedulePossible(context, { payload, eventId }: { eventId: string; payload: RescheduleEventRequest }) {
    return new Promise((resolve, reject) => {
      checkReschedulePossible({
        id: eventId,
        body: {
          ...payload
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  async duplicateEvent(
    { dispatch },
    {
      eventId,
      ...payload
    }: {
      eventId: string;
      payload: EventDuplicateRequest;
    }
  ) {
    return new Promise((resolve, reject) => {
      duplicateEvent({
        id: eventId,
        //@ts-ignore
        body: {
          ...payload
        }
      })
        .then((newEvent: EventResponse) => {
          dispatch(
            'studioToast/triggerToast',
            {
              msg: `Successfully created "${newEvent.title}"`,
              mode: 'success'
            },
            { root: true }
          );
          const { query } = checkAndShowSalesforceConfig();
          resolve({ eventId: newEvent.id, query });
        })
        .catch(reject);
    });
  },
  async duplicateEventViaWorkflow(
    { dispatch },
    {
      eventId,
      ...payload
    }: {
      eventId: string;
      payload: EventDuplicateRequest;
    }
  ) {
    return new Promise((resolve, reject) => {
      duplicateEventViaWorkflow({
        id: eventId,
        //@ts-ignore
        body: {
          ...payload
        }
      })
        .then((newEvent: EventResponse) => {
          dispatch(
            'studioToast/triggerToast',
            {
              msg: `Successfully created "${newEvent.title}"`,
              mode: 'success'
            },
            { root: true }
          );
          const { query } = checkAndShowSalesforceConfig();
          resolve({ eventId: newEvent.id, query });
        })
        .catch(reject);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
